(() => {
  const wrapperSelector = '.xoa-social__app .social-widget-wrapper';
  const coreSource =
    'https://cdn.shopify.com/extensions/019f7dbb-1818-74fa-839d-e375a04f72f7/social-widget-81/assets/social-widget.min.js';

  const initialize = (scope = document) => {
    const wrappers = Array.from(scope.querySelectorAll(wrapperSelector));
    if (!wrappers.length) return;

    window.setTimeout(() => {
      const emptyWrappers = wrappers.filter((wrapper) => wrapper.children.length === 0);
      if (!emptyWrappers.length) return;

      emptyWrappers.forEach((wrapper) => wrapper.removeAttribute('data-initialized'));

      if (typeof window.socialWidgetInitialize === 'function') {
        window.socialWidgetInitialize(emptyWrappers);
        return;
      }

      if (document.querySelector(`script[src="${coreSource}"]`)) return;

      const script = document.createElement('script');
      script.src = coreSource;
      script.async = true;
      script.dataset.xoaSocialwidgetFallback = 'true';
      document.head.appendChild(script);
    }, 2500);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
